import { useContext } from 'react'

import { useElapsedTime } from '@pb/components'

import OPTIMIZELY from 'constants/optimizely'
import { trackOptimizelyEvent } from 'helpers/optimizely'

import { TrackingStateContext } from '../components/ElapsedTimeTracking/ElapsedTimeTrackingProvider'

type UseElapsedTimeTracking = {
  trackElapsedTime: () => void
}

const useElapsedTimeTracking = (optimizelyTrackingConstant?: string): UseElapsedTimeTracking => {
  const trackingStateContext = useContext(TrackingStateContext)
  if (!trackingStateContext) {
    throw new Error('Cannot be used outside ElapsedTimeTrackingProvider')
  }

  const { isTriggered, setIsTriggered } = trackingStateContext
  const { getElapsedTime } = useElapsedTime()

  const trackElapsedTime = (): void => {
    if (isTriggered) {
      return
    }

    const elapsedTime = getElapsedTime()

    trackOptimizelyEvent(
      optimizelyTrackingConstant || OPTIMIZELY.CAPTURE_TIME_ON_PAGE_EVENT,
      undefined,
      {},
      { value: elapsedTime },
    )
    setIsTriggered(true)
  }

  return { trackElapsedTime }
}

export default useElapsedTimeTracking
